/* eslint-disable*/
import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {Accordion, Icon, List, Menu, Sidebar} from 'semantic-ui-react';
import {Link} from 'react-router-dom'; // eslint-disable-line
import {menusArray} from '../constants';
import {parseLeftMenuPath, pushToURL} from '../utils/urlUtils';
import {connect} from 'react-redux';
import {getDentalPartners} from "../redux/modules/auth";
import {getMenusRoles} from "../redux/modules/account";

class SideBarMain extends Component {
    static get propTypes() {
        return {visible: PropTypes.bool};
    }

    static get contextTypes() {
        return {
            store: PropTypes.object
        };
    }

    constructor(props) {
        super(props);
    }

    componentDidMount = () => {
        const {dispatch, user} = this.props;
        dispatch(getDentalPartners(user.id))
        dispatch(getMenusRoles())
    }
    pushToURL = (e, dispatch, childLink) => {
        this.props.closeSideBar(); //Close sidebar on menu click
        pushToURL(e, dispatch, childLink);
    }

    getRolesFromDatabase = (menuRoles, pageId) => {
        const rolesFromDatabase = menuRoles?.filter(menuRole => menuRole.pageId === pageId)[0];
        const roles = rolesFromDatabase?.configuration ? JSON.parse(rolesFromDatabase.configuration).filter(item => item.access === true).map(array => array.role) : []
        roles?.push(this.props.user?.Doctor?.altPay ? 'Doctor.Is.altPay' : 'Doctor.Not.altPay');
        this.props.user?.isAdmin && roles?.push('User.isAdmin');
        return roles;
    }

    handleClick = async (e) => {
        e.preventDefault();
        const {mycdp_uri} = this.props;
        if (mycdp_uri) {
            window.location.href = mycdp_uri;
        }
    };

    renderSubSubMenu = (subSubMenu, j, parentLink, childPath) => {
        const { menuRoles, user } = this.props;
        const { store: { dispatch } } = this.context;
        const userRoles = user?.UdrUsersPermissions?.map(item => item.UdrPermission?.role).filter(Boolean);

        subSubMenu.role = this.getRolesFromDatabase(menuRoles, subSubMenu.pageId);
        if (subSubMenu.role?.length) {
            const roleExist = subSubMenu.role.some(role => userRoles.includes(role));
            const permissionExist = subSubMenu.permissions?.length ? subSubMenu.role.some(role => subSubMenu.permissions.includes(role)) : true;
            if (!roleExist || !permissionExist) {
                return null;
            }
        }

        return (
            <List.Item
                key={`sub-panel-${j}-${subSubMenu.pageId}`}
                as='a'
                className={(childPath === subSubMenu.name.toLowerCase()) ? 'active' : ''}
                onClick={(e) => this.pushToURL(e, dispatch, `${parentLink}${parseLeftMenuPath(subSubMenu.name)}`)}
            >
                {subSubMenu.customIcon ?
                    <i aria-hidden="true" className={`${subSubMenu.customIcon}  icon`}></i> :
                    <Icon name={subSubMenu.icon} />}
                {subSubMenu.title}
            </List.Item>
        );
    }

    renderSubMenu = (subMenu, i, parentLink, basePath) => {
        const { menuRoles, user } = this.props;
        const { store: { dispatch } } = this.context;
        const userRoles = user?.UdrUsersPermissions?.map(item => item.UdrPermission?.role).filter(Boolean);

        subMenu.role = this.getRolesFromDatabase(menuRoles, subMenu.pageId);
        if (subMenu.role?.length) {
            const roleExist = subMenu.role.some(role => userRoles.includes(role));
            if (!roleExist) {
                return null;
            }
        }

        let childPath = location.pathname.split('/')[2];
        childPath = childPath?.includes('-') ? childPath.split('-').join(' ') : childPath;
        const childLink = `${parentLink}${parseLeftMenuPath(subMenu.name)}`;

        if (subMenu.subSubMenus?.length > 0) {
            const subSubMenus = subMenu.subSubMenus
                .map((subSubMenu, subIndex) => this.renderSubSubMenu(subSubMenu, subIndex, parentLink, childPath))
                .filter(Boolean);

            if (subSubMenus.length === 0) return null;

            return {
                key: `panel-${i}-${subMenu.pageId}`,
                title: {
                    content: (
                        <span className={(basePath === subMenu.name) ? 'parentActive' : ''}>
                            {subMenu.customIcon ? <i aria-hidden="true" className={`${subMenu.customIcon}  icon`}></i> : <Icon name={subMenu.icon} />}
                            {subMenu.title}
                            <Icon name="angle down" />
                        </span>
                    )
                },
                content: { content: (<List>{subSubMenus}</List>) }
            };
        }

        return (
            <List key={`listj-${i}`}>
                <List.Item
                    as='a'
                    className={(basePath === subMenu.name) ? 'active' : ''}
                    onClick={(e) => this.pushToURL(e, dispatch, childLink)}
                >
                    {subMenu.customIcon ? <i aria-hidden="true" className={`${subMenu.customIcon}  icon`}></i> : <Icon name={subMenu.icon} />}
                    {subMenu.title}
                </List.Item>
            </List>
        );
    }

    renderMenu = (menu, i, basePath) => {
        const { menuRoles, user } = this.props;
        const parentLink = `${parseLeftMenuPath(menu.name)}`;

        if (menu.subMenus.length > 0) {
            const childMenus = menu.subMenus.map((subMenu, j) => this.renderSubMenu(subMenu, j, parentLink, basePath)).filter(Boolean);
            if (childMenus.length === 0) return null;
            return this.constructParentMenu(menu, i, childMenus, basePath);
        }

        // For leaf menus only: apply DB role check if a DB config entry exists
        const dbConfig = menuRoles?.find(menuRole => menuRole.pageId === menu.pageId);
        if (dbConfig?.configuration) {
            const allowedRoles = JSON.parse(dbConfig.configuration).filter(item => item.access === true).map(item => item.role);
            // DB entry exists but all roles are false → hidden for everyone
            if (allowedRoles.length === 0) return null;
            // DB entry has some roles with access=true → restrict to those roles
            const userRoles = user?.UdrUsersPermissions?.map(item => item.UdrPermission?.role).filter(Boolean) ?? [];
            const roleExist = allowedRoles.some(role => userRoles.includes(role));
            if (!roleExist) return null;
        }

        return this.constructLeafMenu(menu, i, parentLink, basePath);
    }

    constructParentMenu(menu, i, childMenus, basePath) {
        return {
            key: `panel-${i}-${menu.name}`,
            title: {
                content: (
                    <span className={(basePath === menu.name) ? 'parentActive' : ''}>
                        {menu.customIcon ? <i aria-hidden="true" className={`${menu.customIcon}  icon`}></i> : <Icon name={menu.icon} />}
                        {menu.title}
                        <Icon name="angle down" />
                    </span>
                )
            },
            content: {
                content: (
                    <Accordion.Accordion
                        className="ui leftMenu"
                        panels={childMenus}
                    />
                ),
                key: 'sub-accordions'
            }
        };
    }

    constructLeafMenu(menu, i, parentLink, basePath) {
        const { store: { dispatch } } = this.context;
        return {
            key: `panel-${i}-${menu.name}`,
            title: {
                content: (
                    <Link to={parentLink} className={(basePath === menu.name) ? 'active' : ''} onClick={(e) => this.pushToURL(e, dispatch, parentLink)} active={"true"}>
                        {menu.customIcon ? <i aria-hidden="true" className={`${menu.customIcon}  icon`}></i> : <Icon name={menu.icon} />}
                        {menu.title}
                    </Link>
                )
            }
        };
    }
        render() {
        let basePath = location.pathname.split('/')[1];
        basePath = basePath.indexOf('-') > -1
            ? basePath.split('-').join(' ')
            : basePath;

        const basePathIndex = basePath
            ? menusArray.findIndex(i => i.name === basePath)
            : -1;

        const panels = menusArray.filter(f => !f.hide).map((m, i) => this.renderMenu(m, i, basePath)).filter(Boolean);

        return (
            <Sidebar
                as={Menu}
                animation='push'
                width='thin'
                visible={this.props.visible}
                icon='labeled'
                vertical
                inverted
            >
                <a onClick={this.handleClick}>
                    <img src="/images/logoMain.png" className="logo align-self-center" alt="Logo"/>
                </a>
                <Accordion className="leftMenu" panels={panels} defaultActiveIndex={basePathIndex}/>
            </Sidebar>
        );
    }
}

export default connect(
    state => ({
        user: state.get('auth').get('user'),
        mycdp_uri: state.get('auth').get('mycdp_uri'),
        menuRoles: state.get('account').get('menuRoles')
    }))(SideBarMain);
